import { isSet } from "../utils/isSet";
import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import AutoHeight from 'embla-carousel-auto-height';
import ClassNames from 'embla-carousel-class-names';
import { addPrevNextBtnsClickHandlers } from './emblaCarouselControls';
import { addDotBtnsAndClickHandlers } from './emblaCarouselPagination';
import { setupLazyLoadImage } from './emblaCarouselLazyLoad';
import { useNestedEmblaCarousel } from "./emblaNestedCarousel.js";
import { Arrive } from 'arrive';

let setLockParentScroll;
const lockRegistry = new Map();

function initEmblaCarousels(){

    function initHomepageCarousel(){
        const homepageCarouselNodes = document.querySelectorAll('.row-layout--hero-carousel .embla--js');
        if(!isSet(homepageCarouselNodes)) return;

        homepageCarouselNodes.forEach((homepageCarouselNode) => {
            const homepageViewportNode = homepageCarouselNode.querySelector('.embla__viewport');
            if(!isSet(homepageViewportNode)) return;

            const homepageSlideNodes = homepageViewportNode.querySelectorAll('.embla__slide');
            if(!isSet(homepageSlideNodes) || homepageSlideNodes.length === 0) return;

            const dotsNode = homepageCarouselNode.querySelector('.embla__pagination');
    
            const homepageOptions = {
                loop: true
            }

            const homepagePrevBtnNode = homepageCarouselNode.querySelector('.embla__button--prev');
            const homepageNextBtnNode = homepageCarouselNode.querySelector('.embla__button--next');
    
            const homepageEmblaApi = EmblaCarousel(
                homepageViewportNode, 
                homepageOptions,
                []
            );

            if(isSet(dotsNode)){
                const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
                    homepageEmblaApi,
                    dotsNode
                );

                homepageEmblaApi.on('destroy', removeDotBtnsAndClickHandlers);
            }


            if(isSet(homepagePrevBtnNode) && isSet(homepageNextBtnNode)){
                const removeHomepagePrevNextClickHandlers = addPrevNextBtnsClickHandlers(
                    homepageEmblaApi,
                    homepagePrevBtnNode,
                    homepageNextBtnNode
                );

                homepageEmblaApi.on('destroy', removeHomepagePrevNextClickHandlers);
            }

            const loadImagesInView = setupLazyLoadImage(homepageEmblaApi);

            homepageEmblaApi
                .on('init', loadImagesInView)
                .on('reInit', loadImagesInView)
                .on('slidesInView', loadImagesInView)

        });
    }
    initHomepageCarousel();

    function initPopularNewestCarousel(){
        const popularNewestCarouselNodes = document.querySelectorAll('.row-layout--popular-newest-products .embla--js');
        if(!isSet(popularNewestCarouselNodes)) return;

        popularNewestCarouselNodes.forEach((popularNewestCarouselNode, index) => {
            const popularNewestViewportNode = popularNewestCarouselNode.querySelector('.embla__viewport');
            if(!isSet(popularNewestViewportNode)) return;

            const popularNewestSlideNodes = popularNewestViewportNode.querySelectorAll('.card--product');
            if(!isSet(popularNewestSlideNodes) || popularNewestSlideNodes.length === 0) return;

            const dotsNode = popularNewestCarouselNode.querySelector('.embla__pagination');
    
            const popularNewestOptions = {
                breakpoints: {
                    '(min-width: 920px)' : {
                        active: false
                    },
                    '(min-width: 767px)' : {
                        slidesToScroll: 2,
                        
                    }
                },
                loop: false,
                slidesToScroll: 1,
                active: true,
                stopScrollPropagation: true
            }
    
            const popularNewestEmblaApi = EmblaCarousel(
                popularNewestViewportNode, 
                popularNewestOptions,
                []
            );

            setLockParentScroll = useNestedEmblaCarousel(popularNewestEmblaApi);
            const lockId = `lock-${index}`;
            popularNewestCarouselNode.dataset.lockId = lockId;
            lockRegistry.set(lockId, setLockParentScroll);

            if(isSet(dotsNode)){
                const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
                    popularNewestEmblaApi,
                    dotsNode
                );

                popularNewestEmblaApi.on('destroy', removeDotBtnsAndClickHandlers);
            }

            const loadImagesInView = setupLazyLoadImage(popularNewestEmblaApi);

            popularNewestEmblaApi
                .on('init', loadImagesInView)
                .on('reInit', loadImagesInView)
                .on('slidesInView', loadImagesInView)

        });
    }
    initPopularNewestCarousel();


    function initProductCardCarousel(){
        const productCardCarouselNodes = document.querySelectorAll('.card--product .embla--js');
        if(!isSet(productCardCarouselNodes)) return;

        productCardCarouselNodes.forEach((productCardCarouselNode) => {
            const productCardViewportNode = productCardCarouselNode.querySelector('.embla__viewport');
            if(!isSet(productCardViewportNode)) return;

            const productCardSlideNodes = productCardViewportNode.querySelectorAll('.embla__slide');
            if(!isSet(productCardSlideNodes) || productCardSlideNodes.length === 0) return;


            const productCardPrevBtnNode = productCardCarouselNode.querySelector('.embla__button--prev');
            const productCardNextBtnNode = productCardCarouselNode.querySelector('.embla__button--next');

            const dotsNode = productCardCarouselNode.querySelector('.embla__pagination');
    
            const productCardOptions = {
                loop: false,
                stopScrollPropagation: true
            }
    
            const productCardEmblaApi = EmblaCarousel(
                productCardViewportNode, 
                productCardOptions,
                []
            );

            const parentCarouselNode = productCardCarouselNode.closest('.herschel-tablist__tabpanel > .embla--js');

            if (parentCarouselNode) {
                const lockFn = lockRegistry.get(parentCarouselNode.dataset.lockId);

                productCardEmblaApi.on("pointerDown", () => {
                    lockFn?.(true);
                });
                productCardEmblaApi.on("pointerUp", () => {
                    lockFn?.(false);
                });
                productCardEmblaApi.on("pointerLeave", () => {
                    lockFn?.(false);
                });
            }

            if(isSet(dotsNode)){
                const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
                    productCardEmblaApi,
                    dotsNode
                );

                productCardEmblaApi.on('destroy', removeDotBtnsAndClickHandlers);
            }

            if(isSet(productCardPrevBtnNode) && isSet(productCardNextBtnNode)){
                const removeProductCardPrevNextClickHandlers = addPrevNextBtnsClickHandlers(
                    productCardEmblaApi,
                    productCardPrevBtnNode,
                    productCardNextBtnNode
                );

                productCardEmblaApi.on('destroy', removeProductCardPrevNextClickHandlers);
            }
        });
    }
    initProductCardCarousel();

    document.arrive(
        ".card--product .embla--js", 
        function(productCardCarouselNode) {
            const productCardViewportNode = productCardCarouselNode.querySelector('.embla__viewport');
            if(!isSet(productCardViewportNode)) return;

            const productCardSlideNodes = productCardViewportNode.querySelectorAll('.embla__slide');
            if(!isSet(productCardSlideNodes) || productCardSlideNodes.length === 0) return;

            const dotsNode = productCardCarouselNode.querySelector('.embla__pagination');

            const productCardPrevBtnNode = productCardCarouselNode.querySelector('.embla__button--prev');
            const productCardNextBtnNode = productCardCarouselNode.querySelector('.embla__button--next');
    
            const productCardOptions = {
                loop: false,
                stopScrollPropagation: true
            }
    
            const productCardEmblaApi = EmblaCarousel(
                productCardViewportNode, 
                productCardOptions,
                []
            );

            let parentCarouselNode = productCardCarouselNode.closest('.row-layout--popular-newest-products .embla--js');

            if (parentCarouselNode) {
                const lockFn = lockRegistry.get(parentCarouselNode.dataset.lockId);

                productCardEmblaApi.on("pointerDown", () => lockFn?.(true));
                productCardEmblaApi.on("pointerUp", () => lockFn?.(false));
                productCardEmblaApi.on("pointerLeave", () => lockFn?.(false));
            }

            if(isSet(dotsNode)){
                const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
                    productCardEmblaApi,
                    dotsNode
                );

                productCardEmblaApi.on('destroy', removeDotBtnsAndClickHandlers);
            }

            if(isSet(productCardPrevBtnNode) && isSet(productCardNextBtnNode)){
                const removeProductCardPrevNextClickHandlers = addPrevNextBtnsClickHandlers(
                    productCardEmblaApi,
                    productCardPrevBtnNode,
                    productCardNextBtnNode
                );

                productCardEmblaApi.on('destroy', removeProductCardPrevNextClickHandlers);
            }
        }
    );


    function initTestimonialCarousel(){
        const testimonialCarouselNodes = document.querySelectorAll('.row-layout--testimonials .embla--js');
        if(!isSet(testimonialCarouselNodes)) return;

        testimonialCarouselNodes.forEach((testimonialCarouselNode) => {
            const testimonialViewportNode = testimonialCarouselNode.querySelector('.embla__viewport');
            if(!isSet(testimonialViewportNode)) return;

            const testimonialSlideNodes = testimonialViewportNode.querySelectorAll('.embla__slide');
            if(!isSet(testimonialSlideNodes) || testimonialSlideNodes.length === 0) return;
    
            const testimonialOptions = {
                loop: true
            }

            const testimonialPrevBtnNode = testimonialCarouselNode.querySelector('.embla__button--prev');
            const testimonialNextBtnNode = testimonialCarouselNode.querySelector('.embla__button--next');
    
            const testimonialEmblaApi = EmblaCarousel(
                testimonialViewportNode, 
                testimonialOptions,
                [
                    Autoplay({ 
                        delay: 5000,
                        stopOnInteraction: false,
                        stopOnMouseEnter: true,
                        stopOnFocusIn: true
                     })
                ]
            );


            if(isSet(testimonialPrevBtnNode) && isSet(testimonialNextBtnNode)){
                const removeTestimonialPrevNextClickHandlers = addPrevNextBtnsClickHandlers(
                    testimonialEmblaApi,
                    testimonialPrevBtnNode,
                    testimonialNextBtnNode
                );

                testimonialEmblaApi.on('destroy', removeTestimonialPrevNextClickHandlers);
            }

            const loadImagesInView = setupLazyLoadImage(testimonialEmblaApi);

            testimonialEmblaApi
                .on('init', loadImagesInView)
                .on('reInit', loadImagesInView)
                .on('slidesInView', loadImagesInView)

        });
    }

    initTestimonialCarousel();

    function dep__initSubTaxonomyTermsCarousel(){
        const termsCarouselNodes = document.querySelectorAll('.row-layout--terms-slider-section-container .embla--js');
        if(!isSet(termsCarouselNodes)) return;

        termsCarouselNodes.forEach((termsCarouselNode) => {
            const termsViewportNode = termsCarouselNode.querySelector('.embla__viewport');
            if(!isSet(termsViewportNode)) return;

            const termsSlideNodes = termsViewportNode.querySelectorAll('.embla__slide');
            if(!isSet(termsSlideNodes) || termsSlideNodes.length === 0) return;
    
            const termsOptions = {
                loop: false,
                align: 'start',
                dragFree: false
            }

            const termsPrevBtnNode = termsCarouselNode.querySelector('.embla__button--prev');
            const termsNextBtnNode = termsCarouselNode.querySelector('.embla__button--next');
    
            const termsEmblaApi = EmblaCarousel(
                termsViewportNode, 
                termsOptions,
                [ClassNames()]
            );

            if(isSet(termsPrevBtnNode) && isSet(termsNextBtnNode)){
                const removetermsPrevNextClickHandlers = addPrevNextBtnsClickHandlers(
                    termsEmblaApi,
                    termsPrevBtnNode,
                    termsNextBtnNode
                );

                termsEmblaApi.on('destroy', removetermsPrevNextClickHandlers);
            }

            const loadImagesInView = setupLazyLoadImage(termsEmblaApi);

            termsEmblaApi
                .on('init', loadImagesInView)
                .on('reInit', loadImagesInView)
                .on('slidesInView', loadImagesInView)

        });
    }
    dep__initSubTaxonomyTermsCarousel();
}

exports.initEmblaCarousels = initEmblaCarousels